<template>
  <el-dialog
      class="info"
      :visible.sync="showLogVisible"
      :close-on-click-modal="false"
      @closed="closeDialog"
      width="70%"
      title="日志列表"
  >
    <div class="container">
      <el-table
          border
          :data="tableData"
          v-loading="loading"
          highlight-current-row
      >
        <el-table-column
            label="用户"
            width="200"
            property="user_name"
            align="center"
        ></el-table-column>
        <el-table-column
            label="创建时间"
            width="200"
            property="create_time"
            align="center"
        ></el-table-column>
        <el-table-column
            label="日志"
            property="content"
            align="left"
        ></el-table-column>

      </el-table>
    </div>
    <pagination
        :paginationData="paginationData"
        @paginationChange="paginationChange"
    ></pagination>
    <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="showLogVisible = false"
            >关闭</el-button
            >
        </span>
  </el-dialog>
</template>

<script>
import * as api from "@/http/api.js";
import * as oaApi from "@/http/oaApi.js";
import { mapState } from "vuex";
import pagination from "@/comon/components/pagination";
import {workOrderShowLogList} from "@/http/oaApi.js";
export default {
  data() {
    return {
      loading: false,
      tableData: [],
      paginationData: {
        page: 1,
        "per-page": 20,
        total: "",
      },
    };
  },
  components: {
    pagination,
  },
  computed: {},
  props: {
    tableItem: Object,
    showLogVisible: Boolean,
  },
  watch: {
    perPage: {
      handler(newValue) {
        this.perPage = newValue;
        this.workOrderShowLogList();
      },
      deep: true,
      immediate: false,
    },
    page: {
      handler(newValue) {
        this.page = newValue;
        this.workOrderShowLogList();
      },
      deep: true,
      immediate: false,
    },
    showLogVisible: {
      handler(newValue) {
        if (newValue) {
          this.workOrderShowLogList();
        }
      },
    },
  },
  methods: {
    /**
     * 关闭对话框
     */
    closeDialog() {
      this.$emit("update:showLogVisible", false);
    },
    paginationChange(paginationData) {
      this.paginationData = paginationData;
      this.workOrderShowLogList();
    },
    workOrderShowLogList() {
      this.loading = true;
      oaApi
          .workOrderShowLogList(
              {
                ...this.paginationData,
                work_orders_id: this.tableItem.id,
              },
              "get"
          )
          .then((res) => {
            this.loading = false;
            //console.log(res);
            if (res.code == 200) {
              this.tableData = res.data;
              this.paginationData.total = res.total;
            }
          });
    },
  },
};
</script>

<style lang="scss" scoped>
.info {
  .el-dialog__body {
    padding: 20px 40px;
  }
  .el-select,
  .el-date-editor {
    width: 100%;
  }
  .el-form-item {
    .el-form-item__content {
      .el-radio {
        margin: 0;
        width: 100px;
      }
    }
  }
  .container {
    margin-top: 10px;
    min-height: 80px;
    .seccussImg {
      width: 80px;
      margin-top: 18px;
    }
    .seccussText {
      font-size: 18px;
      font-weight: bold;
      line-height: 2;
      margin-top: 18px;
    }
    .tableSchool,
    .tableHealth {
      .el-form-item--small.el-form-item {
        margin-bottom: 0;
      }
    }
  }
}
.edit_table_class {
  z-index: 2200;
}
</style>